/* eslint-disable no-underscore-dangle */

import { createApp } from 'vue'
import App from './color-mixer/App.vue'


// @see https://github.com/parcel-bundler/parcel/issues/6628
globalThis.__VUE_OPTIONS_API__ = false
globalThis.__VUE_PROD_DEVTOOLS__ = false


const app = createApp( App )

app.mount( '#color-mixer' )
